export const WHATSAPP_NUMBER = "5547988553949";
export const WHATSAPP_DISPLAY = "(47) 98855-3949";
export const INSTAGRAM_URL = "https://instagram.com/mw_autocenter";
export const ADDRESS = "Rua Alvim Bauer, 806 – Centro – Balneário Camboriú – SC";
export const HOURS = [
  "Seg a Sex · 08:00 às 12:00",
  "13:30 às 18:00",
  "Sáb · 08:00 às 12:00",
];
export const MAPS_EMBED =
  "https://www.google.com/maps?q=Rua+Alvim+Bauer,+806+-+Centro,+Balne%C3%A1rio+Cambori%C3%BA+-+SC&output=embed";
export const MAPS_DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=Rua+Alvim+Bauer,+806+-+Centro,+Balne%C3%A1rio+Cambori%C3%BA+-+SC";

export const DEFAULT_MESSAGE = "Olá, vim do site da MW e preciso de um serviço.";

export const SERVICE_MESSAGES = {
  alignment: "Olá, vim do site da MW, preciso fazer balanceamento e geometria",
  oil: "Olá, vim do site da MW, preciso fazer troca de óleo",
  brakes: "Olá, vim do site da MW, preciso fazer revisão de freios",
};

export const waLink = (message = DEFAULT_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const IMAGES = {
  hero: "https://customer-assets-cm19k8pv.emergentagent.net/job_maintenance-hub-946/artifacts/anu3jjtm_WhatsApp%20Image%202026-09-23%20at%2016.56.31.jpeg",
  alignment:
    "https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxjYXIlMjB3aGVlbCUyMHJpbSUyMGFsaWdubWVudCUyMHdvcmtzaG9wJTIwZGFya3xlbnwwfHx8fDE3OTAxOTc5ODJ8MA&ixlib=rb-4.1.0&q=85",
  alignmentDetail:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_maintenance-hub-946/artifacts/ap0zqikt_WhatsApp%20Image%202026-09-23%20at%2016.41.05.jpeg",
  oil: "https://images.pexels.com/photos/13065697/pexels-photo-13065697.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  brakes: "https://images.pexels.com/photos/4022543/pexels-photo-4022543.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  workshop:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_maintenance-hub-946/artifacts/8gvk19f8_WhatsApp%20Image%202026-09-23%20at%2017.05.25.jpeg",
  banner:
    "https://images.pexels.com/photos/31215402/pexels-photo-31215402.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
